import React, { useEffect, useRef, useState } from 'react';
import { useChat } from '../contexts/ChatContext';
import { RoomProps } from '../interfaces/interfaces';
import style from "../styles/chat.module.sass"

type UnreadItemType = any

export default function Room(props: RoomProps) {
    const { user, roomSocket, setRoomSocket, mode, token, setLoadingOpenRoom } = useChat()
    const {
        room,
        unreadList,
        setMessages,
        setActiveBox,
        activeRoom,
        setActiveRoom,
        setUserTyping,
        setActiveRoomIndex,
        index,

    } = props;

    // console.log('token', token)

    const [unread, setUnread] = useState<UnreadItemType[] | null>(null);
    const typingTimeoutId = useRef<NodeJS.Timeout | null>(null);

    const handleOpenRoom = async () => {
        setLoadingOpenRoom(true)
        setActiveRoomIndex(index + 1)
        if (roomSocket) {
            roomSocket.close();
        }
        const endpoint = `${process.env.REACT_APP_CURIOBITES_WS_HOST}/ws/api/Chat/${mode}/${token}/${room.id}/`;
        const newSocket = new WebSocket(endpoint);
        setRoomSocket(newSocket);
    };

    const handleSocketEvent = async () => {
        if (!roomSocket) return
        roomSocket.onopen = (event) => {
            console.log('Socket open!', event);
        };


        roomSocket.onmessage = (event) => {
            // console.log('Socket message!');
            const data = JSON.parse(event.data);
            // console.log(data);
            if (data.event_type === 'message_list') {
                setMessages(data.messages);
                setActiveBox(true);
                setActiveRoom(data.room);
                setLoadingOpenRoom(false)
            }

            if (data.event_type === 'new_message') {
                if (user && data.message.sender !== user.id) {
                    setMessages((prev) => [...prev, data.message]);
                }
                setUserTyping(null);
            }

            if (data.event_type === 'typing') {
                setUserTyping(data.sender);

                if (typingTimeoutId.current) {
                    clearTimeout(typingTimeoutId.current);
                }

                // Set a new timeout to reset userTyping to null after 3 seconds
                typingTimeoutId.current = setTimeout(() => {
                    setUserTyping(null);
                }, 2500);
            }
        };

        roomSocket.onerror = (event) => {
            console.log('Error', event);
        };

        roomSocket.onclose = (event) => {
            console.log('Socket closed!', event);
        };
    };

    useEffect(() => {
        if (roomSocket) {
            handleSocketEvent();
        }
    }, [roomSocket]);

    useEffect(() => {
        setUnread(
            unreadList.filter((item) => item.room_id === room.id)
        );
    }, [unreadList]);

    return (
        <div
            data-room={room.id}
            className={activeRoom === room.id ? `${style.room} ${style.active}` : style.room}
            onClick={handleOpenRoom}
        >
            {user && room.users.map((item) => (
                <div key={item.id}>
                    {item.id !== user.id &&
                        <div className={style.room_user}>

                            {item.avatar ? (
                                <img
                                    className={style.room_avatar}
                                    src={item.avatar}
                                    alt={`${item.firstname}'s Avatar`}
                                />
                            ) : (
                                <img
                                    className={style.room_avatar}
                                    src={`https://ui-avatars.com/api/?name=${mode === "Local" ? item.firstname + " " + item.lastname : item.name}&background=random&rounded=true`}
                                    alt={`${item.firstname}'s Avatar`}
                                />
                            )}

                            {mode === "Local" ?

                                <div>
                                    {item.firstname} {item.lastname}
                                </div> :
                                <div>
                                    {item.name}
                                </div>
                            }

                            {unread && unread.length > 0 && (
                                <div className={style.unread_count}>
                                    {unread[0] && unread[0].unread_messages}
                                </div>
                            )}
                        </div>

                    }
                </div>

            ))}
        </div>
    );

} 
